import Cookies from './js.cookie.min.js';

(function($) {

    var $campaign = $(".main-campaign");
    var $campaignWrapper =  $(".main-campaign-wrapper");
    var $campaignCloseAndBackdrop = $(".main-campaign__close, .main-campaign__backdrop");
    var $banner = $(".main-campaign-banner");
    var cookieName = "closedMainCampaign";

    var cookieValue = Cookies.get(cookieName);

    // Expand campaign when not already shown (and closed) and "default expanded" enabled
    if (cookieValue === undefined && $campaign.data("default-expanded") == "True") {
        $banner.addClass("main-campaign-banner--hidden");
        $campaign.removeClass("main-campaign--hidden");
        $campaignWrapper.removeClass("main-campaign-wrapper--clickable");
    }

    $banner.click(function () {
        $campaignWrapper.removeClass("main-campaign-wrapper--clickable");
        $banner.addClass("main-campaign-banner--hidden");
        $campaign.removeClass("main-campaign--hidden");
        Cookies.remove(cookieName);
    });

    $campaignCloseAndBackdrop.click(function () {
        $campaignWrapper.addClass("main-campaign-wrapper--clickable");
        $campaign.addClass("main-campaign--hidden");
        $banner.removeClass("main-campaign-banner--hidden");
        Cookies.set(cookieName, "1", { expires: 7 });
    });

})(jQuery)